import React from "react"
import {ConnectSpinner} from "../../../spinner"

interface StandardLoadingCoverProps {
    testId: string
    ariaValueText: string
}

export const StandardLoadingCover = ({testId, ariaValueText}: StandardLoadingCoverProps) => {
    return <ConnectSpinner testid={testId} ariaValueText={ariaValueText} />
}

export default StandardLoadingCover
